// 导入axios接口
import axiosRequest from '@/utils/axios-default-request'

// 查询职位管理列表信息
let getProjectOrderList = data =>
  axiosRequest.postBodyJson('/clientinterface/getProjectOrderList', data)

// 查询订单类型
let getOrderType = data =>
  axiosRequest.postBody('/clientinterface/getOrderType', data)

// 查询字典信息 订单状态、单位
let getDictTypeData = data =>
  axiosRequest.postBody('/clientinterface/getDictTypeData', data)

// 新增 订单
let addProjectOrder = data =>
  axiosRequest.postBodyJson('/clientinterface/addProjectOrder', data)
// 修改 订单
let editProjectOrder = data =>
  axiosRequest.postBodyJson('/clientinterface/editProjectOrder', data)

// 订单手续费
let getCommissionXQ = data =>
  axiosRequest.postBody('/clientinterface/getCommissionXQ', data)

// 获取订单详情
let getProjectOrderIdData = data =>
  axiosRequest.postBody('/clientinterface/getProjectOrderIdData', data)

// 支付
let getConfirmThePayment = data =>
  axiosRequest.postBodyJson('/clientinterface/getConfirmThePayment', data)

// 确认验收
let getAcceptanceResults = data =>
  axiosRequest.postBodyJson('/clientinterface/getAcceptanceResults', data)

// 调用支付宝支付页面
let getCallPayment = data =>
  axiosRequest.postBody('/clientinterface/getCallPayment', data)
let getPaymentInformation = data =>
  axiosRequest.postBody('/clientinterface/getPaymentInformation', data)

// 译员端------------------------------------------------------------------------------------------------
// 获取订单列表 译员
let getProjectOrderListYY = data =>
  axiosRequest.postBodyJson('/supinterface/getProjectOrderList', data)

//获取订单详情
let getSupProjectOrderIdData = data =>
  axiosRequest.postBody('/supinterface/getProjectOrderIdData', data)

// 接收拒绝订单 译员
let acceptOrRejectProjectOrderYY = data =>
  axiosRequest.postBodyJson('/supinterface/acceptOrRejectProjectOrder', data)

// 交付成果 译员
let getDeliverablesYY = data =>
  axiosRequest.postBodyJson('/supinterface/getDeliverables', data)

// 获取订单状态 译员
let getDictTypeDataYY = data =>
  axiosRequest.postBody('/supinterface/getDictTypeData', data)

// 获取订单手续费 译员
let getCommissionYY = data =>
  axiosRequest.postBody('/supinterface/getCommissionYY', data)

export default {
  getProjectOrderList, // 获取订单列表信息
  addProjectOrder, //添加订单
  getOrderType, //获取订单类型
  getDictTypeData, //获取订单状态
  getCommissionXQ, //获取订单手续费
  getProjectOrderIdData, //获取订单详情
  editProjectOrder, //修改订单
  getConfirmThePayment, //供应商 付款
  getAcceptanceResults, //确认验收
  getCallPayment,
  getPaymentInformation,
  // 译员端------------------
  getProjectOrderListYY,
  acceptOrRejectProjectOrderYY,
  getDictTypeDataYY,
  getDeliverablesYY,
  getSupProjectOrderIdData
}
